import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import BlogCard from './Blogcard';
import './Bloggrid.css';
import { HiOutlineChevronRight, HiOutlineChevronLeft } from "react-icons/hi";
import { getWithoutTokenAPI } from '../../util/Api';
import blog from '../../assets/a1.jpg'

const BlogGrid = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 6;

  const token = useSelector((state) => state.auth?.auth?.access_token);

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      try {
        const res = await getWithoutTokenAPI( '/blog/find-all');
        if (res?.data?.blogs) {
          setBlogPosts(res.data.blogs);
        } else {
          console.error("Failed to fetch blogs", res.error);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };

  
      fetchBlogs();

  }, []);

  const totalPages = Math.ceil(blogPosts.length / ordersPerPage);
  const startIndex = (currentPage - 1) * ordersPerPage;
  const currentBlogs = blogPosts.slice(startIndex, startIndex + ordersPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
 <div className="container  mb-5">
  <div className="row justify-content-center">
    {loading ? (
      <p>Loading blog posts...</p>
    ) : currentBlogs.length > 0 ? (
      currentBlogs.map((post) => (
        <div className=" col-md-6 col-lg-4 mb-4 col-sm-12" key={post._id}>
          <BlogCard
            id={post._id}
            imageUrl={post.images?.[0]}
            date={new Date(post.createdAt).getDate()}
            month={new Date(post.createdAt).toLocaleString('default', { month: 'short' })}
            category={post.tags?.[0]?.name || 'Uncategorized'}
            author={post.author?.name}
            comments={0}
            title={post.title}
            hasPlayButton={false} 
          />
        </div>
      ))
    ) : (
        <div className="empty-wishlist-container">
            <div className="empty-wishlist-content">
              <div className="empty-wishlist-illustration">
                <div className='d-flex justify-content-center'>
           <img src={blog} className='empty-wish-img'></img>
                </div>
             
                <div className="empty-wishlist-message">
                  <h3>No blogs available</h3>
                  <p>Check back soon for updates!</p>
                </div>
              </div>
              
           
              
           
            </div>
          </div>
    )}
  </div>

  {!loading && totalPages > 1 && (
    <div className="pagenos mt-4 d-flex justify-content-center">
      <button
        className="page-btn-left me-2"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <HiOutlineChevronLeft />
      </button>
      {[...Array(totalPages)].map((_, index) => (
        <button
          key={index}
          className={`page-btn-left me-2 ${currentPage === index + 1 ? 'active' : ''}`}
          onClick={() => handlePageChange(index + 1)}
        >
          {index + 1}
        </button>
      ))}
      <button
        className="page-btn-left"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <HiOutlineChevronRight />
      </button>
    </div>
  )}
</div>

  );
};

export default BlogGrid;


// import React, { useEffect, useState } from 'react';
// import { useSelector } from 'react-redux';
// import { HiOutlineChevronRight, HiOutlineChevronLeft } from 'react-icons/hi';
// import { getWithoutTokenAPI } from '../../util/Api';
// import blog from '../../assets/a1.jpg';
// import './Bloggrid.css';

// const BlogGrid = () => {
//   const [blogPosts, setBlogPosts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const ordersPerPage = 6;

//   const token = useSelector((state) => state.auth?.auth?.access_token);

//   useEffect(() => {
//     const fetchBlogs = async () => {
//       setLoading(true);
//       try {
//         const res = await getWithoutTokenAPI('/blog/find-all');
//         if (res?.data?.blogs) {
//           setBlogPosts(res.data.blogs);
//         }
//       } catch (error) {
//         console.error('Error fetching blogs:', error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchBlogs();
//   }, []);

//   const totalPages = Math.ceil(blogPosts.length / ordersPerPage);
//   const startIndex = (currentPage - 1) * ordersPerPage;
//   const currentBlogs = blogPosts.slice(startIndex, startIndex + ordersPerPage);

//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= totalPages) {
//       setCurrentPage(page);
//     }
//   };

//   return (
//     <div className="container mb-5">
//       <div className="row justify-content-center">
//         {loading ? (
//           Array.from({ length: ordersPerPage }).map((_, index) => (
//             <div className="col-md-6 col-lg-4 mb-4 col-sm-12" key={index}>
//               <div className="blog-skeleton-card">
//                 <div className="skeletons-image" />
//                 <div className="skeletons-text title" />
//                 <div className="skeletons-text small" />
//                 <div className="skeletons-text small" />
//               </div>
//             </div>
//           ))
//         ) : currentBlogs.length > 0 ? (
//           currentBlogs.map((post) => (
//             <div className="col-md-6 col-lg-4 mb-4 col-sm-12" key={post._id}>
//               <div className="blog-card">
//                 <img
//                   src={post.images?.[0]}
//                   alt="blog"
//                   className="blog-image"
//                 />
//                 <div className="blog-content">
//                   <p className="blog-date">
//                     {new Date(post.createdAt).getDate()} {new Date(post.createdAt).toLocaleString('default', { month: 'short' })}
//                   </p>
//                   <h5 className="blog-title">{post.title}</h5>
//                   <p className="blog-meta">
//                     {post.author?.name} · {post.tags?.[0]?.name || 'Uncategorized'}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           ))
//         ) : (
//           <div className="empty-wishlist-container">
//             <div className="empty-wishlist-content">
//               <div className="d-flex justify-content-center">
//                 <img src={blog} className="empty-wish-img" alt="no blog" style={{width:"30%"}}/>
//               </div>
//               <div className="empty-wishlist-message">
//                 <h3>No blogs available</h3>
//                 <p>Check back soon for updates!</p>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {!loading && totalPages > 1 && (
//         <div className="pagenos mt-4 d-flex justify-content-center">
//           <button
//             className="page-btn-left me-2"
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//           >
//             <HiOutlineChevronLeft />
//           </button>
//           {[...Array(totalPages)].map((_, index) => (
//             <button
//               key={index}
//               className={`page-btn-left me-2 ${currentPage === index + 1 ? 'active' : ''}`}
//               onClick={() => handlePageChange(index + 1)}
//             >
//               {index + 1}
//             </button>
//           ))}
//           <button
//             className="page-btn-left"
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//           >
//             <HiOutlineChevronRight />
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BlogGrid;

